import { createContext } from 'react'

export interface ImpersonationContextValue {
  // The impersonated user's id, or null when not impersonating. Admin-gated:
  // only non-null when the operator is actually an admin.
  impersonatedIdentityId: string | null
  impersonatedName: string | null
  isImpersonating: boolean
  impersonate: (identityId: string, name?: string) => void
  stopImpersonating: () => void
}

export const ImpersonationContext = createContext<ImpersonationContextValue | null>(null)
